import './my-profile-posts.scss';
import {OptionButton} from "../../../../shared/option-button";
import {useNavigate} from "react-router-dom";
import React from "react";

const MyProfilePosts = () => {
    const navigate = useNavigate();

    return (
        <div>
            <div style={{marginBottom: '1rem', fontWeight: 'bold', fontSize: '1.2rem'}}>
                Work in progress: My Profile Posts
            </div>
            <div>
                De momento puedes acceder a:
                <div style={{
                    backgroundColor: 'rgba(129,129,129,0.05)',
                    padding: '1rem',
                    borderRadius: '16px',
                    marginTop: '0.5rem',
                }}>
                    <OptionButton
                        text="Zona privada"
                        onClick={() => navigate("/my-profile/private")}
                        icon={<i className="fa-solid fa-lock"></i>}/>
                    <OptionButton
                        text="Mis colecciones"
                        onClick={() => navigate("/my-profile/collections")}
                        icon={<i className="fa-solid fa-bookmark"></i>}/>
                    <OptionButton
                        text="Mis reseñas"
                        onClick={() => navigate("/my-profile/reviews")}
                        icon={<i className="fa-solid fa-star"></i>}/>
                </div>
            </div>
        </div>
    )
}

export default MyProfilePosts;
